/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/common/BottomBarConfiguration.yaml
/** @hidden */
export const BottomBarModeValues = ['SOLID', 'GRADIENT', 'HIDDEN'];
//# sourceMappingURL=BottomBarConfiguration.js.map